import { useEffect, useState } from 'react';
import { Emitter } from '@/services/event-emitter';
import { EventTypes } from "@/types/types";
import { SnackbarData } from "@/utils/utils.ts";

export const useSnackbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [snackbarData, setSnackbarData] = useState<SnackbarData | null>(null);

  const handleOpenSnackbar = (data: SnackbarData) => {
    setSnackbarData(data);
    setIsOpen(true);
  };

  const handleCloseSnackbar = () => {
    setIsOpen(false);
    setTimeout(() => {
      setSnackbarData(null);
    }, 300);
  };

  useEffect(() => {
    Emitter.on(EventTypes.OPEN_SNACKBAR, handleOpenSnackbar);

    return () => {
      Emitter.off(EventTypes.OPEN_SNACKBAR, handleOpenSnackbar);
    };
  }, []);

  return {
    isOpen,
    snackbarData,
    handleCloseSnackbar
  };
};
